import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/my/tasks` — "My tasks" is the Home tab with the task board (Kanban ⇄
 * List, "Show tasks where I'm…", drag to Done) — founder 2026-10-04. The
 * private plan stays in My Work.
 */
export const Route = createFileRoute('/my/tasks')({
  beforeLoad: () => {
    throw redirect({ to: '/', search: { tab: 'tasks' }, replace: true });
  },
});
